import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountEarmark } from '../../components/AccountEarmark/AccountEarmark';
import { AccountFees } from '../../components/AccountFees/AccountFees';
import { AccountOwnerSelect } from '../../components/AccountOwnerSelect/AccountOwnerSelect';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { Balance } from '../../components/Balance/Balance';
import { BrokerOfRecord } from '../../components/BrokerOfRecord/BrokerOfRecord';
import { ContributionEndYearSelect } from '../../components/ContributionEndYearSelect/ContributionEndYearSelect';
import { ContributionStartYearSelect } from '../../components/ContributionStartYearSelect/ContributionStartYearSelect';
import { DistributionStrategySelect } from '../../components/DistributionStrategy/DistributionStrategySelect';
import { EmployerMatch } from '../../components/EmployerMatch/EmployerMatch';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { IsSpouseSingleBeneficiary } from '../../components/IsSpouseSingleBeneficiary/IsSpouseSingleBeneficiary';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { GrossEstateCheckbox } from '../../components/GrossEstateCheckbox/GrossEstateCheckbox';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnerSelect />
      <AccountDescription />
      <AccountNickname />
      <Balance label="Current Market Value" />
      <AccountEarmark />
      <GrossEstateCheckbox />
      <BrokerOfRecord />
      <ManagementStyle />
      <AssetBucketing />
    </TabWrapper>
  );
};

const AccountDetails = () => {
  return (
    <TabWrapper>
      <Box
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        `}
      >
        <ContributionStartYearSelect />
        <ContributionEndYearSelect />
      </Box>

      <DistributionStrategySelect />
      <AccountFees />
      <IsSpouseSingleBeneficiary />
    </TabWrapper>
  );
};

export const TaxFree = (props: FormComponentProps) => {
  return (
    <TabsContent
      {...props}
      tabs={[
        { name: 'Summary', Component: Summary },
        { name: 'Employer Match', Component: EmployerMatch },
        { name: 'Details', Component: AccountDetails },
      ]}
    />
  );
};
